import React, { useState,useEffect } from 'react';
import './Passreset.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';


const svg="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Login-Logout/forgetpassword_svg.webp"
const Passreset = () => {
  const [username, setUsername] = useState('');
  const [loading, setLoading]=useState(false);
  const navigate=useNavigate();
    const isptoft = (regno) => {
    if(regno.length == 11 && regno.substring(6,7)=='3' ){
        return true;
    }
    else if(regno.length == 11 &&  regno.substring(6,7)=='2'){
        return true;
    }
    //edge case for some regno to be handled...
    return false;     
}
  const handlePassres = async (e) => {
    e.preventDefault();
    if(isptoft(username)){
      alert("Part-Time / ME  students should contact Admin for password reset.");
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post('/backend/send-otp', { regno:username,});
      // console.log(response.data); 
      navigate('/password-otp',{state:{regno:username,}});
    } catch (error) {
      console.error('Error:', error);
    }finally{
      setLoading(false);
    }
  };
  useEffect(() => {
    document.title = "ACCET-Password Reset";
  }, []);

  return (
    <div>
      <div className="pass-pagef">
        <div className="pass-page">
          <section className="pass-main">
            <div className="pass-container">
                  <p className="pass-title">Password Reset </p>
                  <div className="pass-separator"></div>
                  <p className="pass-welcome-message">Please, provide a valid username to receive OTP</p>
                
                <form className="pass-form" onSubmit={handlePassres}>
                  <div className="form-control">
                    <input
                      className="pass-input"
                      autoComplete="username"
                      type="text"
                      placeholder="Register No."
                      value={username}
                      required
                      onChange={(e) => setUsername(e.target.value.trim())}
                    />
                    <i className="fa fa-user"></i>
                  </div>
                  <button type="submit" className="pass-submit" disabled={loading}>
                    {loading ? 'Sending OTP...' : 'Send OTP'}
                  </button>
                </form>

                  <Link to="/login-page" className="forgot">
                    Remembered Password?
                  </Link>
  
            </div>
          </section>
          <section className="pass-side">
            <img src={svg} alt="" />
          </section>
        </div>
      </div>
    </div>
  );
};

export default Passreset;